import moment from "moment";
import React, { useEffect, useState, useRef } from "react";
import CloseIcon from "../../../assets/icons/new-close.svg";
import SearchIcon from "../../../assets/icons/small-search.svg";
import { ApiGet } from "../../../helpers/API/ApiData";
import Auth from "../../../helpers/Auth";
import Success from "../../Toaster/Success/Success";
import AddUserModal from "../AddUserModal";
import UserInformationModal from "../userInformationModal";
import Popper from "popper.js";
import EditIcon from "../../../assets/icons/Edit.svg";
import FilterIcon from "../../../assets/icons/reminder-filter-icon.svg";

import "./userModal.scss";
export default function UserModal(props) {
  const { setAddUserModalOpen, userInformationModalOpen, setUserInformationModalOpen } = props;
  const userInfo = Auth.getUserDetail();
  const [allAdminOwner, setAllAdminOwner] = useState([]);
  const [allAdminOwners, setAllAdminOwners] = useState([]);
  const [search, setSearch] = useState("");
  const [userDetails, setUserDetails] = useState();
  const [addUserModal, setAddUserModal] = useState(false);
  const [success, setSuccess] = useState(false);
  const [toastmsg, setToastmsg] = useState();
  const [, setEr] = useState();

  const [value, setValue] = useState("All account managers");
  const btnDropdownRef = React.createRef();
  const popoverDropdownRef = React.createRef();
  const wrapperRef = useRef(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [managerDetails, setManagerDetails] = useState([]);
  const [editUSerData, setEditUserData] = useState({});
  const [showFilter, setShowfilter] = useState(true);
  const [statusFilter, setStatusFilter] = useState([]);

  const openDropdownPopover = () => {
    new Popper(btnDropdownRef.current, popoverDropdownRef.current, {
      placement: "bottom-start",
    });
    setDropdownOpen(true);
  };
  const closeDropdownPopover = () => {
    setDropdownOpen(false);
  };

  const handleSelectInput = (data) => {
    const managerName = data?.Name || "All account managers";
    setValue(managerName);
    setDropdownOpen(!dropdownOpen);
    applyUserFilters(statusFilter, search, managerName);
  };

  function useOutsideAlerter(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setDropdownOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }
  useOutsideAlerter(wrapperRef);

  const gettingManagerDetails = async () => {
    await ApiGet("account/manager/getAllmanager")
      .then((res) => {
        // Admin added for select manager Dropdown
        let finalData = [{ count: 0, data: userInfo }].concat(res?.data?.data);
        setManagerDetails(finalData);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    handleAllRole();
    gettingManagerDetails();
  }, []);

  // Keep chips/search/manager filters applied when the full user list refreshes
  useEffect(() => {
    if (!allAdminOwners?.length && statusFilter?.length === 0 && !search && value === "All account managers") {
      setAllAdminOwner(allAdminOwners || []);
      return;
    }
    applyUserFilters(statusFilter, search, value);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [allAdminOwners]);

  const handleAllRole = async () => {
    if (userInfo?.role === "Manager") {
      await ApiGet(`account/manager/count/salon/${userInfo?._id}`)
        .then((res) => {
          const list = [...(res?.data?.data || [])].reverse();
          setAllAdminOwners(list);
          setAllAdminOwner(list);
        })
        .catch((err) => {
          console.log("err", err);
        });
    } else {
      await ApiGet("account/manager/getAllAdminandOwner")
        .then(async (res) => {
          const list = [...(res?.data?.data || [])].reverse();
          setAllAdminOwners(list);
          setAllAdminOwner(list);
        })
        .catch((err) => {
          console.log("err", err);
        });
    }
  };

  const FilterUserData = (e) => {
    const nextSearch = e.target.value;
    setSearch(nextSearch);
    applyUserFilters(statusFilter, nextSearch);
  };

  const OpenUserDetailModal = (data) => {
    setUserInformationModalOpen(!userInformationModalOpen);
    setUserDetails(data);
    if (data === true) {
      setSuccess(true);
      setToastmsg("User Deactivated!");
      handleAllRole();
    }
    if (data === false) {
      setSuccess(true);
      setToastmsg("User activated!");
      handleAllRole();
    }
    if (data === "validity") {
      setSuccess(true);
      setToastmsg("validity added!");
      handleAllRole();
    }
    if (data === "upgrade") {
      setSuccess(true);
      setToastmsg("account upgrade!");
      handleAllRole();
    }
  };

  const AddNewuserModal = (data) => {
    setAddUserModal(!addUserModal);
    setEditUserData();
    if (data === true) {
      handleAllRole();
      setSuccess(true);
      setToastmsg("User added sucessfully!");
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setSuccess(false);
      setEr();
    }, 1500);
    return () => clearTimeout(timer);
  });

  const EdituserModal = (data) => {
    setEditUserData(data);
    setAddUserModal(!addUserModal);
    if (data === true) {
      setEditUserData();
      handleAllRole();
      setSuccess(true);
      setToastmsg("User edited sucessfully!");
    }
  };

  const getAccountStatus = (fil) => {
    const isActive = fil?.accountData?.[0]?.isActive === true;
    const days = Number(fil?.noOfDays) || 0;
    if (!isActive) return "Deactive";
    if (days === 0) return "Expired";
    return "Active";
  };

  const isPaidAccount = (fil) => {
    const monetize = fil?.monetize;
    if (!Array.isArray(monetize) || monetize.length === 0) return false;
    const paymentData = monetize[0]?.paymentData;
    return Array.isArray(paymentData) && paymentData.length > 0;
  };

  const applyUserFilters = (nextStatusFilter, nextSearch = search, managerName = value) => {
    let list = Array.isArray(allAdminOwners) ? [...allAdminOwners] : [];

    // Account manager dropdown
    if (managerName && managerName !== "All account managers") {
      const manager = managerDetails
        ?.map((m) => m?.data)
        ?.find((d) => d?.Name === managerName);
      if (manager?._id) {
        list = list.filter((account) => {
          const parentId = account?.accountData?.[0]?.parentId;
          if (String(parentId) === String(manager._id)) return true;
          if (parentId === undefined && manager?.role === "SuperAdmin") return true;
          return false;
        });
      }
    }

    // Status / payment chips (OR within group, AND across groups)
    const selected = Array.isArray(nextStatusFilter) ? nextStatusFilter : [];
    const statusKeys = ["Active", "Deactive", "Expired"].filter((k) =>
      selected.includes(k)
    );
    const paymentKeys = ["Paid", "Unpaid"].filter((k) => selected.includes(k));

    if (statusKeys.length > 0 || paymentKeys.length > 0) {
      list = list.filter((fil) => {
        const statusOk =
          statusKeys.length === 0 ||
          statusKeys.includes(getAccountStatus(fil));
        const paid = isPaidAccount(fil);
        const paymentOk =
          paymentKeys.length === 0 ||
          (paymentKeys.includes("Paid") && paid) ||
          (paymentKeys.includes("Unpaid") && !paid);
        return statusOk && paymentOk;
      });
    }

    // Search
    const q = (nextSearch || "").trim().toLowerCase();
    if (q) {
      list = list.filter(
        (obj) =>
          (obj?.accountData?.[0]?.businessName &&
            obj.accountData[0].businessName.toLowerCase().includes(q)) ||
          (obj?.accountData?.[0]?.mobileNumber &&
            obj.accountData[0].mobileNumber.toString().includes(q))
      );
    }

    setAllAdminOwner(list);
  };

  const userStatusFilter = (e, key) => {
    if (e?.stopPropagation) e.stopPropagation();
    const prev = Array.isArray(statusFilter) ? statusFilter : [];
    const next = prev.includes(key)
      ? prev.filter((k) => k !== key)
      : [...prev, key];
    setStatusFilter(next);
    applyUserFilters(next);
  };

  return (
    <>
      <div className="user-modal-wrapper">
        <div className="full-page-header-alignment">
          <div className="header-title">
            <div onClick={() => setAddUserModalOpen(false)}>
              <img src={CloseIcon} alt="CloseIcon" />
            </div>
            <h2>Users</h2>
          </div>
          <div className="blue-button" onClick={() => AddNewuserModal()}>
            <button>Add new user</button>
          </div>
        </div>
        <div className="full-page-body-top-alignment">
          <div className="all-content-alignment">
            <div className="user-modal-all-data-width">
              <div className="sub-header-alignment">
                <div className="manager-filter-align">
                  <h5>Total number of user accounts created - {allAdminOwner?.length} </h5>
                  {userInfo?.role !== "Manager" && (
                    <div
                      className="relative-custom-select"
                      ref={wrapperRef}
                      onClick={() => {
                        dropdownOpen ? closeDropdownPopover() : openDropdownPopover();
                      }}
                    >
                      <div className="search-relative select-relative-div" ref={btnDropdownRef}>
                        <input type="text" style={{ cursor: "pointer" }} disabled value={value} />
                        <div className="search-icon-alignment">
                          <svg width="8" height="4" viewBox="0 0 8 4" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1 0.5L4 3.5L7 0.5" stroke="#1479FF" stroke-linecap="round" stroke-linejoin="round" />
                          </svg>
                        </div>
                      </div>

                      <div
                        className={
                          dropdownOpen
                            ? "custom-select-react-dropdown custom-select-react-dropdown-open"
                            : "custom-select-react-dropdown custom-select-react-dropdown-hidden"
                        }
                        ref={popoverDropdownRef}
                      >
                        <div className="all-menu-alignment" onClick={(e) => handleSelectInput({ Name: "All account managers" })}>
                          <div className="menu-list">
                            <span>{"All account managers"}</span>
                          </div>
                        </div>
                        {managerDetails?.map((drop) => {
                          return (
                            <div className="all-menu-alignment" onClick={(e) => handleSelectInput(drop?.data)}>
                              <div className="menu-list">
                                <span>{drop?.data?.Name}</span>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  )}
                </div>

                <div>
                  <div className="search-relative">
                    <input type="text" placeholder="Search user" value={search} onChange={(e) => FilterUserData(e)} />
                    <div className="search-icon-alignment">
                      <img src={SearchIcon} alt="SearchIcon" />
                    </div>
                  </div>
                </div>
              </div>
              {userInfo?.role !== "Manager" && (
                <div style={{ display: "flex", justifyContent: "flex-end", marginTop: "20px" }}>
                  <div
                    className={
                      showFilter ? "sub-button-style-filters cus-invoice-icon-designs-are" : "cus-invoice-icon-designs cus-invoice-icon-designs-are"
                    }
                    onClick={() => (showFilter ? "" : setShowfilter(!showFilter))}
                  >
                    {!showFilter && (
                      <div className="iconic-tab">
                        <div className="iconic-icon">
                          <img src={FilterIcon} alt="FilterIcon" />
                        </div>
                        <div className="iconic-icon-hover">
                          <img src={FilterIcon} alt="FilterIcon" />
                        </div>
                        <p className="iconic-title">Filters</p>
                      </div>
                    )}
                    {showFilter ? (
                      <div style={{ display: "flex", marginRight: "15px" }}>
                        <div
                          className={statusFilter.includes("Active") ? "filter-data-btns-paid-active " : "filter-data-btns-paid"}
                          onClick={(e) => userStatusFilter(e, "Active")}
                        >
                          <button>Active</button>
                        </div>
                        <div
                          className={statusFilter.includes("Deactive") ? "filter-btn-clicked-active " : "filter-btn-clicked"}
                          onClick={(e) => userStatusFilter(e, "Deactive")}
                        >
                          <button>Deactive</button>
                        </div>
                        <div
                          className={statusFilter.includes("Expired") ? "filter-btn-clicked-expire-active " : "filter-btn-clicked-expire"}
                          onClick={(e) => userStatusFilter(e, "Expired")}
                        >
                          <button>Expired</button>
                        </div>
                        <div
                          className={statusFilter.includes("Paid") ? "filter-btn-clicked-paid-active " : "filter-btn-clicked-paid"}
                          onClick={(e) => userStatusFilter(e, "Paid")}
                        >
                          <button>Paid</button>
                        </div>
                        <div
                          className={statusFilter.includes("Unpaid") ? "filter-btn-clicked-active " : "filter-btn-clicked"}
                          onClick={(e) => userStatusFilter(e, "Unpaid")}
                        >
                          <button>Unpaid</button>
                        </div>

                        {/* <div style={{ marginLeft: "15px", marginTop: "2px" }}>
                        <img src={CloseTab} alt="CloseTab-red" style={{ marginRight: "14px" }} onClick={() => setShowfilter(!showFilter)} />
                      </div> */}
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              )}

              <div className="user-data-table-show">
                <table>
                  <tr>
                    <th align="left">#</th>
                    <th align="left">Date</th>
                    <th align="left">Salon name</th>
                    <th align="left">Type</th>
                    <th align="left">Mobile number</th>
                    <th align="left">Country</th>
                    <th align="left">Validity</th>
                    <th align="center">Account status</th>
                    <th align="center">Payment status</th>
                    {userInfo?.role !== "Manager" && <th align="center"></th>}
                  </tr>
                  {allAdminOwner.map((elem, i) => {
                    return (
                      <tr
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          OpenUserDetailModal(elem);
                        }}
                      >
                        <td align="left">
                          <div className="normal-text-style">
                            <span>{i + 1}</span>
                          </div>
                        </td>
                        <td align="left">
                          <div className="normal-text-style">
                            <span>{moment(elem?.accountData[0]?.created).format("DD MMM YY")}</span>
                          </div>
                        </td>
                        <td align="left">
                          <div className="normal-text-style">
                            <span>{elem?.accountData[0]?.businessName}</span>
                          </div>
                        </td>
                        <td align="left">
                          <div className="normal-text-style">
                            <span>{elem?.accountData[0]?.role}</span>
                          </div>
                        </td>
                        <td align="left">
                        <div className="normal-text-style" style={{minWidth: "160px"}}>
                            <span>+{elem?.accountData[0]?.dialCode} {elem?.accountData[0]?.mobileNumber}</span>
                          </div>
                        </td>
                        <td align="left">
                          <div className="normal-text-style">
                            <span>{elem?.accountData[0]?.countryName}</span>
                          </div>
                        </td>
                        <td align="left">
                          <div className="normal-text-style">
                            <span>{elem?.noOfDays} days</span>
                          </div>
                        </td>
                        {elem?.accountData[0]?.isActive ? (
                          elem?.noOfDays === 0 ? (
                            <td align="center">
                              <div className="status-button-style-expire">
                                <button>{"Expired"}</button>
                              </div>
                            </td>
                          ) : (
                            <td align="center">
                              <div className="status-button-style">
                                <button>{elem?.accountData[0]?.isActive && "Active"}</button>
                              </div>
                            </td>
                          )
                        ) : (
                          <td align="center">
                            <div className="status-button-style-deactive">
                              <button>{"Deactivated"}</button>
                            </div>
                          </td>
                        )}
                        {elem?.noOfDays !== 0 && elem?.monetize?.[0]?.paymentData?.length !== 0 ? (
                          <td align="center">
                            <div className="paid-button-style">
                              <button>Paid</button>
                            </div>
                          </td>
                        ) : elem?.noOfDays === 0 && elem?.monetize?.length === 0 ? (
                          <td align="center"></td>
                        ) : elem?.noOfDays === 0 && elem?.monetize?.[0]?.paymentData?.length === 0 ? (
                          <td align="center"></td>
                        ) : elem?.noOfDays === 0 && elem?.monetize?.[0]?.paymentData?.length !== 0 ? (
                          <td align="center">
                            <div className="paid-button-style">
                              <button>Paid</button>
                            </div>
                          </td>
                        ) : (
                          <td align="center">
                            <div className="paid-button-style">
                              <button>Unpaid</button>
                            </div>
                          </td>
                        )}

                        {userInfo?.role !== "Manager" && (
                          <td align="left">
                            <div
                              onClick={(e) => {
                                EdituserModal(elem?.accountData[0]);
                                e.stopPropagation();
                              }}
                            >
                              <img src={EditIcon} alt="EditIcon" />
                            </div>
                          </td>
                        )}
                      </tr>
                    );
                  })}
                  {userInformationModalOpen && (
                    <UserInformationModal toggle={OpenUserDetailModal} userDetails={userDetails} EdituserModal={EdituserModal} />
                  )}
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {addUserModal && (
        <AddUserModal toggle={AddNewuserModal} editUSerData={editUSerData} EdituserModal={EdituserModal} addUserModal={addUserModal} />
      )}
      {success && <Success modal={success} toastmsg={toastmsg} />}
    </>
  );
}
